
    import { Component, Emit, Prop, Vue } from 'nuxt-property-decorator';
    import { namespace } from 'nuxt-property-decorator';
    import { getComponentsMap } from '@/components';
    import { getComponentMeta } from '@/store/editor';

    let editor = namespace('editor');

    @Component
    export default class OptionsFieldsAdditionalComponentsList extends Vue {
        @Prop() value;
        @Prop() filter;
        @Prop({ default: false }) multiple!: boolean;
        @editor.State components;
        @editor.State componentsList;

        selected: String | [] = this.multiple ? [] : '';
        values = [] as any;

        @Emit('input')
        onChange(val) {
            return val;
        }

        mounted() {
            //console.log(this.componentsList);

            this.values = [
                {
                    text: 'Нет компонента',
                    value: null
                }
            ];

            const componentsMap = getComponentsMap();

            for (let name in componentsMap) {
                const meta = getComponentMeta(name);
                if (meta) {
                    if (
                        (this.filter &&
                            typeof this.filter === 'function' &&
                            this.filter(meta)) ||
                        !this.filter
                    ) {
                        this.values.push({
                            text: meta ? meta.title : '',
                            value: name
                        });
                    }
                }
            }

            if (!this.value) {
                this.values.forEach((val: any) => {
                    if (val.selected) {
                        this.selected = val.value;
                    }
                });
            } else {
                this.selected = this.value;
            }
        }
    }
